import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NavigationService } from '@services/nav/nav.service';
import { TestHooks } from './aps-edit-anchor.hooks';

@Component({
	selector: 'app-aps-edit-anchor',
	templateUrl: './aps-edit-anchor.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ApsEditAnchorComponent {
	testHooks = TestHooks;
	@Input() hiddenIconOnBlur: boolean = false;
	@Input() href: string = '';
	@Input() fragment: string = '';
	@Input() text: string;
	@Input() backgroundColor: string = 'bg-white';

	get completedHref(): string {
		return this.fragment ? `${this.href}#${this.fragment}` : this.href;
	}

	constructor(private navService: NavigationService) {}

	redirect(event: MouseEvent): void {
		event.preventDefault();
		this.navService.goToUrl(this.href, null, { fragment: this.fragment });
	}
}
